var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0162 0.14855L5.19151 5.83199C5.34309 6.03777 5.65333 6.03777 5.80372 5.83199L9.98022 0.14855C9.9905 0.134572 9.99665 0.118056 9.99801 0.100834C9.99936 0.0836129 9.99586 0.0663576 9.98789 0.050981C9.97992 0.0356045 9.96779 0.0227079 9.95285 0.01372C9.93791 0.00473261 9.92074 4.76837e-06 9.90325 6.1512e-05H9.01514C8.95474 6.1512e-05 8.89791 0.0292912 8.86238 0.0772281L5.49821 4.65579L2.13404 0.0772281C2.09852 0.0292912 2.04168 6.1512e-05 1.98128 6.1512e-05H1.09317C1.0162 6.1512e-05 0.971205 0.0865822 1.0162 0.14855Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.cb1612e8af12808a7b7763bf83acb234.svg";
export { ForwardRef as ReactComponent };